// extracted by mini-css-extract-plugin
export default {"languageIcon":"Project_languageIcon__7waF2"};